import { render, staticRenderFns } from "./carbon-reduction-per-country.vue?vue&type=template&id=3fb705c7&scoped=true&"
import script from "./carbon-reduction-per-country.vue?vue&type=script&lang=js&"
export * from "./carbon-reduction-per-country.vue?vue&type=script&lang=js&"
import style0 from "./carbon-reduction-per-country.vue?vue&type=style&index=0&id=3fb705c7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb705c7",
  null
  
)

export default component.exports